import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MASKS } from 'ng-brazil';
import { Subscription } from 'rxjs';
import { Auth } from 'src/app/models/auth';
import { BeneficioValor } from 'src/app/models/BeneficioValor';
import { Colaborador } from 'src/app/models/colaborador';
import { CollaboratorDetailsModel } from 'src/app/models/CollaboratorDetailsModel';
import { TransferenciaBeneficio } from 'src/app/models/transferencia-beneficio';
import { TransferenciaBeneficioModel } from 'src/app/models/transferencia-beneficio-model';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ColaboradorService } from 'src/app/services/colaborador.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';


@Component({
    selector: 'app-transfere-beneficio',
    templateUrl: './transfere-beneficio.component.html',
    styleUrls: ['./transfere-beneficio.component.css']
})
export class TransfereBeneficioComponent implements OnInit, OnDestroy {
    private routeSubscription: Subscription;
    private colaboradorID: number;
    private currentUser: Auth;
    public beneficioValorSelecionado: BeneficioValor;
    public collaboratorDetailsModel: CollaboratorDetailsModel
    public colaborador: Colaborador;
    public historicoTransferencia: TransferenciaBeneficioModel[] = [];
    public qtdBeneficio: number;
    public mensagemValidacao: string = '';
    public MASKS = MASKS;

    public contaCredito: any;
    public accontCtrl: FormControl = new FormControl();
    public valueCtrl: FormControl = new FormControl();
    public valor: any;

    constructor(private router: Router,
        private activatedRoute: ActivatedRoute,
        private colaboradorService: ColaboradorService,
        private authenticationService: AuthenticationService,
        private modalService: NgbModal,
        private alertService: NewAlertService,
        private pedidoService: PedidoService) {

        this.routeSubscription = this.activatedRoute.paramMap.subscribe(params => {
            this.colaboradorID = + params.get('colaboradorID');
        });

        this.currentUser = this.authenticationService.currentUserValue;
    }


    ngOnInit() {
        this.colaboradorService.getById(this.colaboradorID, this.currentUser.token.assignorGuid).subscribe(
            response => {
                this.colaborador = response.result;
                if(this.colaborador.pessoaGuid)
                    this.ObterDetalhes();
            }
        );

        this.ObterHistorico();
    }

    ngOnDestroy() {
        this.routeSubscription.unsubscribe();
    }

    ObterDetalhes() {
        this.colaboradorService.GetDetails(this.colaborador.pessoaGuid, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
            response => {
                this.collaboratorDetailsModel = response.result;
            }
        );
    }

    ClearMessage() {
        this.mensagemValidacao = '';
    }

    TransferirBeneficio(valor: string = null, contaCreditoGuid: string = null) {

        this.valor = this.valueCtrl.value;
        this.contaCredito = this.accontCtrl.value;
        valor = this.valueCtrl.value;
        contaCreditoGuid = this.accontCtrl.value;

        this.mensagemValidacao = '';
        //valor = valor.replace('R$', '').replace(/\./g, '').replace(',', '.').trim();

        let transferenciaBeneficio = new TransferenciaBeneficio();
        let valido: boolean = true;
        this.mensagemValidacao = '';

        if (contaCreditoGuid == 'NA') {
            valido = false;
            this.mensagemValidacao = 'Selecione uma conta para continuar';
        }

        if (!valor || +valor == 0 || +valor > this.beneficioValorSelecionado.valorBeneficio) {
            valido = false;
            this.mensagemValidacao = 'Valor inválido';
        }

        if (valido) {
            transferenciaBeneficio.valor = +valor;
            transferenciaBeneficio.cedenteGuid = this.currentUser.token.assignorGuid;
            transferenciaBeneficio.gestorResponsavelResgateGuid = this.currentUser.token.userReferenceId;

            transferenciaBeneficio.contaDestinoGuid = contaCreditoGuid;
            transferenciaBeneficio.contaOrigemGuid = this.beneficioValorSelecionado.contaGuid;

            this.pedidoService.TransfereBeneficio(transferenciaBeneficio).subscribe(
                response => {
                    this.collaboratorDetailsModel.currentProduct = response.result;
                    this.ObterHistorico();
                    this.modalService.dismissAll();
                }
            );
        }
    }

    goToBack() {
        this.router.navigate(['../../list'], { relativeTo: this.activatedRoute });
    }

    ObterHistorico() {
        this.pedidoService.ObterHistoricoTransferenciaBeneficio(this.colaboradorID, this.currentUser.token.assignorGuid).subscribe(
            response => {
                if (response.status === 1) {
                    this.historicoTransferencia = response.result;
                } else {
                    this.historicoTransferencia = [];
                }

            }, error => {
                this.alertService.error('Ocorreu um erro ao buscar os detalhes do favorecido');
            });
    }


    ShowModal(content: any, beneficioValor: BeneficioValor) {
        this.mensagemValidacao = '';
        this.valueCtrl.setValue(null);
        this.accontCtrl.setValue(null);
        this.qtdBeneficio = this.collaboratorDetailsModel?.currentProduct.filter(x =>
            //x.produtoCategoria == beneficioValor.produtoCategoria &&
            x.nomeBeneficio != beneficioValor.nomeBeneficio
            ).length
        this.beneficioValorSelecionado = beneficioValor;
        this.modalService.open(content, { centered: true });
    }
}
